// extracted by mini-css-extract-plugin
export default {"container":"Xm-z","blurb":"Ym-z","links":"Zm-z"};